import { ref, computed, onMounted, onUnmounted } from "vue";
function useDirection() {
  const getDirection = () => {
    if (typeof document === "undefined") return "ltr";
    return document.documentElement.getAttribute("dir") || document.body.getAttribute("dir") || "ltr";
  };
  const dir = ref(getDirection());
  const isRtl = computed(() => dir.value === "rtl");
  let observer = null;
  onMounted(() => {
    if (typeof document === "undefined") return;
    dir.value = getDirection();
    observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && (mutation.attributeName === "dir" || mutation.attributeName === "lang")) {
          dir.value = getDirection();
        }
      });
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["dir", "lang"]
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["dir", "lang"]
    });
  });
  onUnmounted(() => {
    if (observer) {
      observer.disconnect();
    }
  });
  return {
    dir,
    isRtl
  };
}
export {
  useDirection
};
//# sourceMappingURL=useDirection.js.map
